import { MortgageCalculatorJson } from "../Apps/MortgageCalculatorJson"

function AppMortgageCalculatorJson() {

  return (
    <MortgageCalculatorJson />
  )
}

export default AppMortgageCalculatorJson